const map = {
	"./ai-custom-solution-1.webp": 33805,
	"./ai-custom-solution-2.webp": 60096,
	"./ai-custom-solution-3.webp": 43139,
	"./ai-custom-solution-4.webp": 50078,
	"./ai-custom-solution-5.webp": 61113,
	"./current-platform-1.webp": 61064,
	"./current-platform-13.webp": 381,
	"./current-platform-14.webp": 39788,
	"./current-platform-2.webp": 96021,
	"./current-platform-3.webp": 79018,
	"./current-platform-4.webp": 32199,
	"./current-platform-5.webp": 68164,
	"./current-platform-6.webp": 86337,
	"./current-platform-7.webp": 16582,
	"./current-platform-8.webp": 24739
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32647;